import { useQuery } from '@tanstack/react-query'
import { systemKeyQueries } from '../api'

export const useGetCommonQuery = () => useQuery(systemKeyQueries.list())
